import { EMPTY_OBJECT } from '../../../constants/common'
import { isValueBooleanType } from '../../../utils/common'

export function isTablePaginationNavigationIconShown({
  isMobileScreenSize,
  nextButtonText,
} = EMPTY_OBJECT) {
  return (
    !isValueBooleanType(isMobileScreenSize) ||
    isMobileScreenSize ||
    nextButtonText === null
  )
}
